import React, { Component } from 'react';
import { DropdownItem } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { NavLink as RouterLink, withRouter } from 'react-router-dom';

import routeTemplates from 'ui/common/routes/templates';
import Menu from 'ui/common/menu';

export class AdminNavItems extends Component {
  render() {
    return (
      <li className="nav-item my-auto pr-3">
        <Menu
          text={
            <FormattedMessage
              id="app.layout.header.adminsdh"
              defaultMessage="Tribe Academy Admin"
            />
          }
          isButton
        >
          <DropdownItem tag={RouterLink} to={routeTemplates.admin.users.index}>
            <FormattedMessage id="app.layout.header.admin.users" defaultMessage="Users" />
          </DropdownItem>
          <DropdownItem tag={RouterLink} to={routeTemplates.admin.companies.root}>
            <FormattedMessage id="app.layout.header.admin.companies" defaultMessage="Courses" />
          </DropdownItem>
          <DropdownItem tag={RouterLink} to={routeTemplates.admin.profiler.root}>
            <FormattedMessage id="app.layout.header.admin.profiler" defaultMessage="Entry Test" />
          </DropdownItem>
          <DropdownItem tag={RouterLink} to={routeTemplates.admin.hiring.root}>
            <FormattedMessage
              id="app.header.layout.admin.hiring"
              defaultMessage="Hiring Companies"
            />
          </DropdownItem>
          {/* <DropdownItem tag={RouterLink} to={routeTemplates.admin.preassess.root}>
            <FormattedMessage
              id="app.layout.header.admin.pre-assess"
              defaultMessage="Pre Assessments"
            />
          </DropdownItem> */}
          {/* <DropdownItem tag={RouterLink} to={routeTemplates.admin.behavassess.root}>
            <FormattedMessage
              id="app.layout.header.admin.behav-assess"
              defaultMessage="Behavioural Assessments"
            />
          </DropdownItem> */}
          {/* <DropdownItem tag={RouterLink} to={routeTemplates.admin.skills.root}>
            <FormattedMessage id="app.layout.header.admin.skills" defaultMessage="Skills" />
          </DropdownItem> */}
          {/* <DropdownItem tag={RouterLink} to={routeTemplates.admin.badges.root}>
            <FormattedMessage id="app.layout.header.admin.badges" defaultMessage="Badges" />
          </DropdownItem> */}
          {/* <DropdownItem tag={RouterLink} to={routeTemplates.admin.claims.root}>
            <FormattedMessage id="app.layout.header.admin.claims" defaultMessage="Claims" />
          </DropdownItem> */}
          {/* <DropdownItem tag={RouterLink} to={routeTemplates.admin.assignments.root}>
            <FormattedMessage
              id="app.layout.header.admin.assignments"
              defaultMessage="Assignments"
            />
          </DropdownItem> */}
          {/* <DropdownItem tag={RouterLink} to={routeTemplates.admin.stats.root}>
            <FormattedMessage id="app.layout.header.admin.stats" defaultMessage="Stats" />
          </DropdownItem> */}
          {/* <DropdownItem tag={RouterLink} to={routeTemplates.admin.templates.root}>
            <FormattedMessage id="app.layout.header.admin.templates" defaultMessage="Templates" />
          </DropdownItem> */}
          {/* <DropdownItem tag={RouterLink} to={routeTemplates.admin.features.root}>
            <FormattedMessage id="app.layout.header.features.stats" defaultMessage="Features" />
          </DropdownItem> */}
        </Menu>
      </li>
    );
  }
}

export default withRouter(AdminNavItems);



// WEBPACK FOOTER //
// ./src/ui/app/layout/header/admin.js